<script setup lang="ts">
const benefits = [
  {
    title: 'Semua Ekspedisi, Satu Tempat',
    icon: 'material-symbols:wand-stars-outline',
    description:
      'Tidak perlu buka banyak website. Cukup satu platform untuk JNE, J&T, SiCepat, AnterAja, Ninja, dan lainnya.'
  },
  {
    title: 'Real-Time & Akurat',
    icon: 'material-symbols:speed-outline',
    description:
      'Data tracking langsung dari sistem ekspedisi, update otomatis setiap kali status berubah.'
  },
  {
    title: 'Notifikasi Otomatis ke Pelanggan',
    icon: 'material-symbols:notifications-active-outline',
    description:
      'Seller/Brand bisa kirim update status paket ke WhatsApp pembeli secara otomatis — reputasi toko tetap aman.'
  }
]

const faqs = [
  {
    question: 'Apakah bisa cek resi lebih dari satu sekaligus?',
    answer:
      'Bisa! Gunakan fitur “Cek Banyak Resi” di Dashboard KiriminAja untuk input massal.'
  },
  {
    question: 'Apa saja ekspedisi yang bisa dicek?',
    answer:
      'Hampir semua ekspedisi besar di Indonesia seperti JNE, J&T, SiCepat, AnterAja, Ninja Xpress, IDExpress, TIKI, Paxel, dan lainnya.'
  },
  {
    question: 'Kenapa status pengiriman belum update?',
    answer:
      'Beberapa ekspedisi melakukan update berkala 1–2 jam sekali. Coba refresh atau cek lagi beberapa saat.'
  }
]

const items = [
  'Upload & lacak ribuan resi dari berbagai ekspedisi langsung dari satu dashboard.',
  'Sinkron otomatis dari webstore & toko online.',
  'Notifikasi real-time ke pelanggan via WhatsApp Follow-up.',
  'Laporan pengiriman & status paket otomatis tersusun.'
]

useDefaultMeta({
  title: 'Cek Resi JNE, J&T, SiCepat, Ninja, AnterAja, NCS, ID Express'
})
</script>
<template>
  <TrackingHero />
  <PresetBenefit
    benefit-title="Kenapa Lacak Paket di KiriminAja?"
    :benefits="benefits"
  />
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    title="Kelola Ribuan Paket Sekaligus? Gunakan Dashboard KiriminAja"
    hero-image="/images/dashboard-member-banner-1.webp"
    :items="items"
    button-label="Selengkapnya"
    class="py-12"
  />

  <PresetCourier path="/tracking" />
  <FaqBase title="Pertanyaan Seputar Cek Resi KiriminAja" :faqs="faqs" />

  <CtaSection />
</template>
